import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Heading3: FC<TextProps> = props => (
  <Text
    as="h3"
    fontSize="heading3"
    {...props}
    className={classNames(props.className, 'text_heading2')}
  />
);

export default Heading3;
